import { Component, OnInit, ViewChild, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { document } from '@app/_models/document';
import { LogService } from '@app/_shared/log.service';
import { stream } from '@app/_models/stream';
import { price } from '@app/_models/price';
import { college } from '@app/_models/college';
import { branch } from '@app/_models/branch';
import { semester } from '@app/_models/semester';
import { AddUser } from '@app/_models/addUser';
import { associateDocList } from '@app/_models/associateDocList';
import { YearOfPassing } from '@app/_models/yearOfPassing';

@Component({
  selector: 'app-common-menu',
  templateUrl: './common-menu.component.html',
  styleUrls: ['./common-menu.component.css']
})
export class CommonMenuComponent implements OnInit {

  public routeVal = '';
  receiveVal($event) {
    this.routeVal = $event;
  }
  parentMessage: document;
  streamData: stream;
  priceData: price;
  collegeData: college;
  userData: AddUser;
  branchData: branch;
  semesterData: semester;
  roleId: string;
  associateData: associateDocList;
  yearOfPassingData: YearOfPassing;

  constructor(private eventService: LogService) { }
  public newData = ''
  response: any;

  callRoute(dataValue) {
    this.eventService.emit<string>(dataValue);
  }

  ngOnInit(): void {

    this.eventService.on<string>().subscribe(
      data => {
        this.response = data;
        console.log(this.response + "dataValue")
        if (this.response.dataValue == 6) {
          this.newData = this.response.dataValue;
          this.parentMessage = this.response.data;
          console.log("parentMessage ,..." + this.response)
        }
        else if (this.response.dataValue == 9) {
          this.response = data;
          this.newData = this.response.dataValue;
          this.streamData = this.response.data;
          console.log("streamData ,..." + this.response)
        }
        else if (this.response.dataValue == 12) {
          this.response = data;
          this.newData = this.response.dataValue;
          this.priceData = this.response.data;
          console.log("priceData ,..." + this.response)
        }
        else if (this.response.dataValue == 15) {
          this.response = data;
          this.newData = this.response.dataValue;
          this.collegeData = this.response.data;
          console.log("collegeData ,..." + this.response)
        }
        else if (this.response.dataValue == 18) {
          this.response = data;
          this.newData = this.response.dataValue;
          this.userData = this.response.data;
          console.log("userData ,..." + this.response)
        }
        else if (this.response.dataValue == 23) {
          this.response = data;
          this.newData = this.response.dataValue;
          this.branchData = this.response.data;
          console.log("branchData ,..." + this.response)
        }
        else if (this.response.dataValue == 25) {
          this.response = data;
          this.newData = this.response.dataValue;
          this.semesterData = this.response.data;
          console.log("semesterData ,..." + this.response)
        }
        else if (this.response.dataValue == 32) {
          this.response = data;
          this.newData = this.response.dataValue;
          this.associateData = this.response.data;
          console.log( "collegeData ,..."+ this.response)
        }
        else if (this.response.dataValue == 37) {
          this.response = data;
          this.newData = this.response.dataValue;
          this.yearOfPassingData = this.response.data;
          console.log( "YearOfPassingData ,..."+ this.response)
        }
        else {
          this.newData = data
        }


        this.routeVal = this.newData
        console.log(this.newData + "final")
      }
    )

    this.roleId = localStorage.getItem('currentRole');
    if (this.roleId == "3")//for verifier
    {
      this.callRoute('27');
    }
    else if (this.roleId == "4")//for super verifier
    {
      this.callRoute('28');
    }
    else if (this.roleId == "5")//for  super Admin
    {
      this.callRoute('29');
    }
    else if (this.roleId == "6")//for  Associate
    {
      this.callRoute('30');
    }
    else if (this.roleId == "8")//for super Associate
    {
      this.callRoute('31');
    }
    else if (this.roleId == "7")//for university
    {
      this.callRoute('26');
    }
   
  }

}

